export default "__VITE_ASSET__C7O9_4e$__"